import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { PostListItemStyledProps, PostListStylesProps } from './types'

const PostListContainerStyled = styled.div`
  width: 100%;
`
const PostListPaginationStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
`

const PostListItemStyled = styled.li<PostListItemStyledProps>`
  padding: 0 0.625rem 0.625rem;
  width: 100%;

  @media ${media.phone} {
    padding: 0 0.625rem 3.125rem;
    flex-basis: ${({ cols }) => 100 / (cols?.phone || 2)}%;
    max-width: ${({ cols }) => 100 / (cols?.phone || 2)}%;
  }

  @media ${media.tablet} {
    flex-basis: ${({ cols }) => 100 / (cols?.tablet || 3)}%;
    max-width: ${({ cols }) => 100 / (cols?.tablet || 3)}%;
  }
`

const PostListStyled = styled.ul<WithTheme<PostListStylesProps>>`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.625rem;

  ${({ isColumn }) =>
    isColumn &&
    css`
      @media ${media.tablet} {
        margin: 0;
        ${PostListItemStyled} {
          flex-basis: 100%;
          max-width: 100%;
          padding: 0;
          &:not(:last-of-type) {
            margin-bottom: 1.75rem;
          }
        }
      }
    `};
`

export { PostListContainerStyled, PostListPaginationStyled, PostListStyled, PostListItemStyled }
